import { render, staticRenderFns } from "./user-wallet-transaction.vue?vue&type=template&id=6f870672"
import script from "./user-wallet-transaction.vue?vue&type=script&lang=js"
export * from "./user-wallet-transaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports